module.exports = __webpack_public_path__ + "static/media/zhaobiao_bg.1930f25a.png";